import React, { useState } from 'react'
import styled from 'styled-components'

// components
import DropDown from '../../../components/dropdown/DropDown'

// globals
import * as TYPE from '../../../globals/type'

// styles
import colors from '../../../styles/colors'

// images
import SearchImg from '../../../assets/image/search/ic-search.png'

function Search({
  orderCategory,
  orderStatus,
  handleSearchOption,
  handleSearch,
}) {
  return (
    <>
      <DivideLine />

      <SearchWrapper>
        <DropdownSearch>
          <CategoryDropDown
            title={orderCategory}
            options={[TYPE.ORDER.ALL, TYPE.ORDER.DELIVERY, TYPE.ORDER.PICK_UP]}
            defaultOption={TYPE.ORDER.DEFAULT}
            setOption={(opt) => handleSearchOption(opt, 0)}
            value={orderCategory}
          />

          <StatusDropDown
            title={orderStatus}
            options={[
              TYPE.STATUS.ALL,
              TYPE.STATUS.COMPLETE,
              TYPE.STATUS.CANCEL,
              TYPE.STATUS.PROGRESS,
            ]}
            defaultOption={TYPE.STATUS.DEFAULT}
            setOption={(opt) => handleSearchOption(opt, 1)}
            value={orderStatus}
          />
        </DropdownSearch>
        <SubmitSearch>
          <span onClick={handleSearch}>
            <h1>조회</h1>
            <img src={SearchImg} />
          </span>
        </SubmitSearch>
      </SearchWrapper>
    </>
  )
}

export default Search

const DivideLine = styled.div`
  height: 1px;
  margin: 15px 0 20px;
  background-color: ${colors.W4};

  @media ${(props) => props.theme.mobile} {
    margin: 16px 0 15px;
  }
`

const SearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;

  @media ${(props) => props.theme.mobile} {
    flex-direction: column;
    margin-bottom: 1px;
  }
`

const DropdownSearch = styled.div`
  width: 100%;
  display: flex;

  /* .dropdown {
    flex: 1;
    margin-right: 10px;
    margin-bottom: 0px !important;

    .show {
      @media ${(props) => props.theme.mobile} {
        font-size: 14px;
      }
    }
  } */

  button {
    width: 95%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media ${(props) => props.theme.mobile} {
      font-size: 14px;
    }
  }

  @media ${(props) => props.theme.mobile} {
    width: 100%;
    justify-content: space-between;
  }
`

const CategoryDropDown = styled(DropDown)`
  .dropdown {
    flex: 1;
    margin-right: 10px;
    margin-bottom: 0px !important;

    .show {
      @media ${(props) => props.theme.mobile} {
        font-size: 14px;
      }
    }
  }
`

const StatusDropDown = styled(DropDown)`
  .dropdown {
    flex: 1;
    margin-right: 10px;
    margin-bottom: 0px !important;

    @media ${(props) => props.theme.mobile} {
      margin-right: 0px;
    }

    .show {
      @media ${(props) => props.theme.mobile} {
        font-size: 14px;
      }
    }
  }
`

const SubmitSearch = styled.div`
  span {
    display: flex;
    width: 48px;
    height: 48px;
    border-radius: 24px;
    background-color: ${colors.mainG};
    color: ${colors.W1};
    justify-content: center;
    align-items: center;
    cursor: pointer;

    h1 {
      display: none;

      @media ${(props) => props.theme.mobile} {
        display: flex;
        font-size: 16px;
        font-weight: 400;
      }
    }

    img {
      width: 19px;
      height: 19px;

      @media ${(props) => props.theme.mobile} {
        display: none;
      }
    }

    @media ${(props) => props.theme.mobile} {
      width: 100%;
      height: 40px;
      border-radius: 8px;
    }
  }

  @media ${(props) => props.theme.mobile} {
    width: 100%;
    margin-top: 16px;
  }
`
